module.exports = __webpack_public_path__ + "static/media/canstar-2021-2022-award-143x70.c2e7b430.svg";